

export default () => {
    $(".minute-by-minute-page").find(".hide-show-content").on("click", function(){
        $(".cmp-timeline").find(".items-cont").slideToggle();
        if($(this).hasClass("show-content")){
            $(this).toggleClass("hide-content show-content");
            $(this).find("span").text("Mostrar");
        }else{
            $(this).toggleClass("show-content hide-content");
            $(this).find("span").text("Ocultar");
        }
        $(this).addClass("hide-content");
        $(this).find("i").toggleClass("fa-chevron-up fa-chevron-down");
    });
}
